'use client'

import {useFieldContext} from '../../integrations/form/index.js'
import {Tabs, TabsRootProps} from '@chakra-ui/react'
import {ReactNode} from 'react'

export interface TabItem {
  key: string
  trigger: ReactNode
}

interface Props extends Omit<TabsRootProps, 'value' | 'onValueChange'> {
  tabs: TabItem[]
}

export function TabsField({tabs, children, ...props}: Props) {
  const field = useFieldContext<string>()

  return (
    <Tabs.Root value={field.state.value} onValueChange={e => field.handleChange(e.value)} {...props}>
      <Tabs.List>
        {tabs.map(tab => (
          <Tabs.Trigger key={tab.key} value={tab.key}>
            {tab.trigger}
          </Tabs.Trigger>
        ))}
      </Tabs.List>
      {children}
    </Tabs.Root>
  )
}
